import { useState } from "react";
import { useSelector } from "react-redux";

import { BrandHeader } from "components";
import WithLoading from "components/Hoc/WithLoading";
import { NotFound, ErrorComponent } from "components";
import CategoriesList from "components/menu/CategoriesList";
import StoreHeaderDetail from "components/StoreHeaderDetail";
import StoreCategoryWithMenu from "components/menu/StoreCategoryWithMenu";
import RecommendedITemList from "components/recommended-item/RecommendedITemList";
import useGetRecommendedItems from "service-hooks/useGetRecommendedItems";
import { navConfigKeys } from "components/brandHeader/UserNavPanel";
import DiscountsAndLoyalty from "components/discounts-loyalty";

import { useMenuSearch, usePlatform } from "hooks";
import useEventTracker from "hooks/useEventTracker";

import { isItemOutOfStock } from "utils/Utils";
import useDineIn from "modules/dine-in/hooks/useDineIn";
import OrdersFeedback from "modules/dine-in/Home/containers/OrdersFeedback";
import Menu from "../../menu/containers";

import C from "Constants";
import "./style.css";

const DineInHome = () => {
  usePlatform();
  useEventTracker({
    name: "HOME_DINE_IN",
    orderType: "DINE_IN",
    shouldLog: true,
  });

  // Hooks
  const { itemList } = useGetRecommendedItems();
  const {
    viewBasketPage,
    goToLogin,
    goToSettings,
    params,
    router,
    queryParam,
    DomainType,
  } = useDineIn();
  

  // State
  const [open, setOpen] = useState(false);
  const [openOrdersFeedback, setOpenOrdersFeedback] = useState(false);
  const [searchTerm, setSearch] = useState("");
  const [openItemDetails, setOpenItemDetails] = useState({
    open: false,
    params: null,
    type: null,
  });
  
  // Selectors
  const { notFound, brandMenuError } = useSelector((state) => state?.brand);
  const { storeMenu ,selectedStore} = useSelector((state) => state?.store)
  const { cart } = useSelector((state) => state?.cart);
  const { brandInfo } = useSelector(
    (state) => state?.brandStorageReducer
  );
  const { isLoading } = useSelector((state) => ({
    isLoading: state?.loader.isLoading,
  }));

  // Handlers
  const { filteredMenu } = useMenuSearch(searchTerm, storeMenu);
  const handleSearch = (value) => {
    setSearch(value?.toLowerCase());
  };

  const openItemDetailPage = (item, category, type) => {
    if (!selectedStore?.isOpened) {
      setOpen(true);
    }
    if (
      selectedStore?.isOpened &&
      !isItemOutOfStock(item?.itemId, selectedStore) &&
      item?.itemId?._id &&
      category?._id
    ) {
      // if (type && type === "modal") {
      //   const modalParams = {
      //     itemId: item?.itemId?._id,
      //     catId: category?._id,
      //     domainName: DomainType,
      //   };

      //   setOpenItemDetails({
      //     open: true,
      //     params: modalParams,
      //     type: type,
      //   });
      //   return;
      // }
      let MainURl = "/dine-in/item/";
      let TempUrl = `/${params?.domainName}${MainURl}${item?.itemId?._id}/${category?._id}`;
      let RootUrl = `${MainURl}${item?.itemId?._id}/${category?._id}`;
      router(RootUrl, TempUrl, DomainType, {...item, type:"modal"}, `?${queryParam}`);
    }
  };

  if (!isLoading && notFound) return <NotFound message={notFound} />;
  return (
    <>
      <WithLoading>
        <div className="dine-in-home-container store-page store-page-popup h-full">
          <BrandHeader
            page={true}
            hideUserNavPanel={false}
            userNavPanelProps={{
              navIconConfig: [navConfigKeys.search, navConfigKeys.cart],
              searchTerm: searchTerm,
              authClick: goToLogin,
              userClick: goToSettings,
              handleSearch: handleSearch,
              cartClick: viewBasketPage,
              showBackButton: true,
              backButtonClick : openOrdersFeedback ? () => setOpenOrdersFeedback(false) : null
            }}    
          />
          <StoreHeaderDetail
            page={C.BRAND}
            brandInfo={brandInfo}
            description={C.SERVICE_TYPE.DINE_IN}
            headerTitle={selectedStore?.baseLanguage?.name}
            activeServices={[]}
            maxStars={5}
            hideDescription={true}
            containerStyleProps={{
              style: {
                padding: "16px",
                paddingBottom: "0px",
              },
            }}
            hideStoreRatting={true}
            // showArrow={reviewsInfo ? true : false}
            showArrow={false}
            // rating={reviewsInfo ? reviewsInfo?.rating : 0}
            onNavigateClick={() => setOpenOrdersFeedback((prev) => !prev)}
          />
         {
          openOrdersFeedback ? (
            <OrdersFeedback reviewsInfo={{}} />
          )
         :
         <>
          <DiscountsAndLoyalty />
          {searchTerm?.length <= 0 && (
            <div className="sticky top-0 bg-white px-4 shadow-md" style={{zIndex: 5}}>
              <CategoriesList
                categoriesList={filteredMenu}
                showHeading={true}
                showIcon={false}
                scrollOffset={200}
                showSeeAll={false}
              />
            </div>
          )}

          <RecommendedITemList
            itemidList={itemList}
            setOpen={setOpen}
            openStoreItem={openItemDetailPage}
            // type="modal"
          />

          {brandMenuError && <ErrorComponent error={brandMenuError} />}
          <Menu menu={storeMenu} {...{ filteredMenu, searchTerm, setSearch }} hideFooter={openItemDetails?.open}>
              <StoreCategoryWithMenu
                menu={filteredMenu}
                menuType={C.BRAND_BASED_CATADienInHomeLOGUE}
                onItemClick={openItemDetailPage}
                {...{ open, setOpen }}
                page="store"
                showCartIcon={true}
                // type="modal"
              />           
            {
              cart?.length > 0 && (
                <>
                  <br/>
                  <br/>
                </>
              )}
             <br/>
             <br/>
          </Menu>
          </>}
        </div>
      </WithLoading>
    </>
  );
};

export default DineInHome;
